import React from 'react';
import PropTypes from 'prop-types';
import PersonIcon from '@material-ui/icons/Person';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import LocalMallIcon from '@material-ui/icons/LocalMall';
import MoodIcon from '@material-ui/icons/Mood';
import StorefrontIcon from '@material-ui/icons/Storefront';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import './Stepper.css';
import { useIsMobile } from 'lib/utils';

const Stepper = ({ currentStep, steps }) => {
  const isMobile = useIsMobile();
  const containerClass = isMobile ? 'steps-horizontal' : 'steps-vertical';
  const itemClass = isMobile ? 'step-horizontal' : 'step-vertical';
  const iconClass = isMobile ? 'step-horizontal-icon' : 'step-vertical-icon';
  // const containerClass = isMobile ? 'steps-horizontal' : 'steps-vertical';
  // const itemClass = isMobile ? 'step-horizontal' : 'step-vertical';
  // const iconClass = isMobile ? 'step-horizontal-icon' : 'step-vertical-icon';

  const getStepIcon = (stepNumber) => {
    switch (stepNumber) {
      case 1:
        return <MoodIcon />;
      case 2:
        return <LocalMallIcon />;
      case 3:
        return <StorefrontIcon />;
      case 4:
        return <FingerprintIcon />;
      case 5:
        return <AccountBalanceIcon />;
      default:
        return <PersonIcon />;
    }
  };

  return (
    <div className={containerClass}>
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isComplete = stepNumber < currentStep;
        const isActive = stepNumber === currentStep;

        return (
          <div
            key={stepNumber}
            className={`${itemClass} ${isComplete ? 'complete' : ''} ${isActive ? 'active' : ''}`}
            role="listitem"
            aria-current={isActive ? 'step' : undefined}
            title={isMobile ? step.title : undefined}
          >
            <div className={iconClass}>
              {isComplete ? <CheckCircleIcon /> : getStepIcon(stepNumber)}
            </div>
            {!isMobile && <div className="step-vertical-content">
              <h4>{step.title}</h4>
              <p>{step.description}</p>
            </div>}
          </div>
        );
      })}
    </div>
  );
};

Stepper.propTypes = {
  currentStep: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default Stepper;
